var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echart-container"},[_c('div',{ref:"echartTarget",staticClass:"echart-target"})])
}
var staticRenderFns = []

export { render, staticRenderFns }